module.exports = __webpack_public_path__ + "media/images/iconPaginateNext__errorRed-b01760210604697aa0a20588e4033a7b.png";